import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';

import { ButtonT3Theme } from '../../components/lib/ButtonT3/constants';
import QATags from '../../constants/QATags';
import { setTimeout } from '../../tools/Globals';

import { ModalBody, ModalContainer, ModalIcon, ModalSingleButton, ModalTitle } from './Modal';

import './ModalCoachmarkDialog.scss';

class ModalCoachmarkDialog extends React.Component {
  static propTypes = {
    onClose: PropTypes.func,
    iconGlyph: PropTypes.node,
    title: PropTypes.node,
    body: PropTypes.node,
    ctaButtonText: PropTypes.node,
    ctaButtonUrl: PropTypes.string,
    ctaButtonFunc: PropTypes.func,
    ctaButtonShouldNotClose: PropTypes.bool,
    closeButtonShouldNotClose: PropTypes.bool,
    closeButtonText: PropTypes.node,
    closeButtonUrl: PropTypes.string,
    closeButtonFunc: PropTypes.func,
    timeout: PropTypes.number,
    router: PropTypes.object,
    isBlueOverlay: PropTypes.bool,
    isTranslucentBodyText: PropTypes.bool,
    iconStyleNames: PropTypes.string,
    className: PropTypes.string,
    footerContent: PropTypes.node,
  };

  static defaultProps = {
    timeout: 15000,
  };

  componentDidMount() {
    if (this.props.timeout) {
      this.timer = setTimeout(this.onTimeout, this.props.timeout);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  onTimeout = () => {
    this.props.onClose();
    if (this.props.closeButtonUrl) {
      this.props.router.push(this.props.closeButtonUrl);
    }
  };

  renderCTAButtonOnClick = () => {
    if (!this.props.ctaButtonShouldNotClose) {
      this.props.onClose();
    }
    if (this.props.ctaButtonFunc) {
      this.props.ctaButtonFunc();
    }
    if (this.props.ctaButtonUrl) {
      this.props.router.push(this.props.ctaButtonUrl);
    }
  };

  renderCloseButtonOnClick = () => {
    if (!this.props.closeButtonShouldNotClose) {
      this.props.onClose();
    }
    if (this.props.closeButtonFunc) {
      this.props.closeButtonFunc();
    }
    if (this.props.closeButtonUrl) {
      this.props.router.push(this.props.closeButtonUrl);
    }
  };

  render() {
    // @TODO WEBCLIENT-3995 createBEM needed
    const coachmarkClasses = classNames('Modal--coachmarkDialog', {
      [`Modal--coachmarkDialog--${this.props.className}`]: this.props.className,
    });

    return (
      <ModalContainer className={coachmarkClasses} isBlueOverlay={this.props.isBlueOverlay}>
        <div className='Modal--coachmarkDialogContent'>
          {this.props.iconGlyph ? (
            <ModalIcon glyph={this.props.iconGlyph} styleNames={this.props.iconStyleNames} />
          ) : null}
          {this.props.title ? <ModalTitle>{this.props.title}</ModalTitle> : null}
          {this.props.body ? (
            <ModalBody isTranslucentBodyText={this.props.isTranslucentBodyText}>
              {this.props.body}
            </ModalBody>
          ) : null}
          {this.props.ctaButtonText && (this.props.ctaButtonFunc || this.props.ctaButtonUrl) ? (
            <ModalSingleButton
              text={this.props.ctaButtonText}
              action={this.renderCTAButtonOnClick}
              isBlock={true}
              theme={ButtonT3Theme.DARK}
              qaTag={QATags.MCDCTA}
            />
          ) : null}
          {this.props.closeButtonText ? (
            <ModalSingleButton
              text={this.props.closeButtonText}
              action={this.renderCloseButtonOnClick}
              isBlock={true}
              theme={ButtonT3Theme.DARK_TRANSPARENT}
              qaTag={QATags.MCDC}
            />
          ) : null}
        </div>
        {this.props.footerContent ? (
          <div className='Modal--coachmarkDialogFooter'>{this.props.footerContent}</div>
        ) : null}
      </ModalContainer>
    );
  }
}

export default withRouter(ModalCoachmarkDialog);
